const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB, getINP }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getINP(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

// LCP: Largest Contentful Paint: Loading performance - Should be within 2.5 seconds of loading a page
  // Percieved load speed, tells when page's main content has likely loaded. Literally: render time of the largest element 
    // (image, text block, video, etc) visibile in the view port relative to when the page is navigated to. 
// INP: Interaction to Next Paint: Interractivity - Should be within 200 milliseconds
  // Check responiveness by observing input latency over the lifespan of a user's visit to a page. Works an all inputs
// CLS: Cumulative Layout Shift: Visual Stability - Should be 0.1 or less
  // Measures largest burts of layout shift scores for unexpected layout shifts in a page's lifecycle
// FID: First Input Delay: Time between first interaction and when browser starts processing that interaction - Should be less than 100ms
  // Only measures delay in event processing, not entire delay
  // FID has been replaced by INP, so we should move into using INP as a metric
// FCP: First Contentful Paint: Time between first navigate to page and when page's content is rendered on screen - Should be less than 1.8 sec
  // Used for measure percieded load speed. Mainly for user satisfaction or letting them know something is happening
// TTFB: Time to First Byte: Time between resource request and when first byte of response arrives - Should be less than 800ms
  // Used for measuring connection setup time and web server responsiveness. Identifies when a server is too slow


export default reportWebVitals;
